import { useResetAtom } from 'jotai/utils';
import type { RecorderInitiator } from '~/atoms/recorder-atoms';
import { fastAutoHealAtom } from '~/atoms/recorder-atoms';
import { useLiveStateManager } from '~/hooks/useLiveStateManager';
import { erroredOperationAtom } from '~/atoms/no-code-atoms';
import { useSetAtom } from 'jotai';
import { aiChatLogsAtomFamily } from '~/atoms/ai-chat-atoms';

export const useStartRecorder = ({ testContentId }: { testContentId: string }) => {
  const { updateLiveState } = useLiveStateManager();
  const resetFastAutoHeal = useResetAtom(fastAutoHealAtom);
  const resetErroredOperation = useResetAtom(erroredOperationAtom);
  const setAILogs = useSetAtom(aiChatLogsAtomFamily(testContentId));

  return (initiator: RecorderInitiator) => {
    // Immediate parent context is the nearest parent context to the operation
    // This is used to determine the cursor location
    const parentContext =
      initiator.location?.type === 'operation-id' && initiator.location.parentContexts ?
        initiator.location.parentContexts.at(-1)
      : undefined;

    resetErroredOperation();
    resetFastAutoHeal();
    updateLiveState((_) => ({
      vmStatus: undefined,
      recorderInitiator: {
        ...initiator,
        location: initiator.location ? { ...initiator.location, parentContext } : undefined,
      },
      recorderCursor:
        initiator.location ?
          {
            ...initiator.location,
            stepOrder: 0,
            operation:
              initiator.location.type === 'operation-id' && initiator.location.operationId ?
                {
                  id: initiator.location.operationId,
                  order: initiator.location.operationOrder,
                }
              : undefined,
          }
        : undefined,
    }));
    setAILogs({ type: 'startNewLog' });
  };
};
